import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ProfileTypeService } from '../../../../core/services/contact/contact-type/contact-type.service'
import { NgxMaskDirective } from 'ngx-mask'
import {MatSlideToggle} from '@angular/material/slide-toggle';

@Component({
  selector: 'contact-patient-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    NgxMaskDirective,
    MatSlideToggle,
  ],
  templateUrl: './contact-client-form.component.html',
  styleUrl: './contact-client-form.component.scss',
  providers: [ProfileTypeService],
  standalone: true,
})
export class ContactClientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private contactTypeService: ProfileTypeService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
  //  this.getListType()
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  // getListType() {
  //   this.contactTypeService.listContactType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('name')?.setValue(this.editItem.nome)
    this.form.get('typeContact')?.setValue(this.editItem.parentesco)
    this.form.get('phone')?.setValue(this.editItem.telefone.slice(2))
    this.form.get('email')?.setValue(this.editItem.email)
    this.form.get('active')?.setValue(this.editItem.enviar_email)
  }

  resetForm() {
    this.form.reset()
    this.form.get('active')?.setValue(true)

  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      typeContact: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: [''],
      active: [true],
    })
  }

  getTypeDescription() {
    let typeId = this.form.get('typeContact')?.value
    if (typeId) {
      let element = this.listType.find((ele: any) => {
        return ele.id === typeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createContact() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        nome: this.form.controls['name'].value,
        parentesco: this.form.controls['typeContact'].value,
        telefone: '55'+this.form.controls['phone'].value,
        email: this.form.controls['email'].value,
        enviar_email: this.form.controls['active'].value,
      }
    } else {
      return {
        nome: this.form.controls['name'].value,
        parentesco: this.form.controls['typeContact'].value,
        telefone: '55'+this.form.controls['phone'].value,
        email: this.form.controls['email'].value,
        enviar_email: this.form.controls['active'].value,
      }
    }
  }
}
